.select {
  display: flex;
  flex-direction: column;

  background-color: var(--field);

  border: 1px solid var(--border-strong);
  border-radius: var(--radius-s);

  overflow: hidden;
}

.head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-xs);

  padding: var(--space-xs) var(--space-s);

  background-color: var(--surface-sunken);

  border-block-end: 1px solid var(--border);
}

.allLabel {
  font-size: var(--size-200);
  font-weight: var(--weight-medium);
}

.headActions {
  display: flex;
  align-items: center;
  gap: var(--space-2xs);
}

.summary {
  margin-inline-end: var(--space-2xs);

  font-size: var(--size-100);
  font-variant-numeric: tabular-nums;

  color: var(--text-faint);
}

/*
 * The catalog is long. Capping the box keeps the rest of the form reachable
 * without collapsing the tree into something you cannot navigate.
 */
.scroller {
  max-height: 460px;

  padding: var(--space-xs) var(--space-s);

  overflow-y: auto;
}

.branch {
  display: flex;
  flex-direction: column;

  margin: 0;
  padding: 0;

  list-style: none;
}

/* Nesting is drawn by the indent, so the depth needs no class of its own. */
.node > .branch,
.leaf > .branch {
  margin-inline-start: var(--space-m);
  padding-inline-start: var(--space-xs);

  border-inline-start: 1px solid var(--border);
}

.row {
  display: flex;
  align-items: center;
  gap: var(--space-2xs);

  padding: var(--space-3xs) var(--space-2xs);

  border-radius: var(--radius-s);
}

.row:hover {
  background-color: rgb(255 255 255 / 5%);
}

.pick {
  display: flex;
  align-items: center;
  gap: var(--space-xs);

  min-width: 0;

  cursor: pointer;
}

.pick:has(input:disabled) {
  color: var(--text-faint);

  cursor: default;
}

.topicTitle {
  font-size: var(--size-200);
  font-weight: var(--weight-medium);
}

.questionTitle {
  font-size: var(--size-200);

  color: var(--text-muted);
}

.count {
  margin-inline-start: auto;

  font-size: var(--size-100);
  font-variant-numeric: tabular-nums;

  color: var(--text-faint);
}

.twisty {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 1.25rem;
  height: 1.25rem;
  padding: 0;

  font-size: var(--size-200);

  color: var(--text-faint);
  background-color: transparent;

  border: none;
  border-radius: var(--radius-s);

  cursor: pointer;
}

.twisty:hover {
  color: var(--accent);
  background-color: var(--surface-raised);
}

/* Keeps a row without a twisty lined up with the rows that have one. */
.twistyGap {
  display: inline-block;

  width: 1.25rem;
  flex-shrink: 0;
}

.tag {
  padding: 0 var(--space-2xs);

  font-size: var(--size-100);

  color: var(--text-muted);
  background-color: rgb(255 255 255 / 8%);
  border-radius: var(--radius-s);
}

.empty {
  font-size: var(--size-200);

  color: var(--text-muted);
}

/**
 * Returns a selection to nothing. It sits where the select-all row sits in the
 * question tree, because in a picker of single nodes there is nothing to select
 * all of.
 */
.clear {
  background: none;
  border: none;
  color: var(--accent);
  cursor: pointer;
  font: inherit;
  font-size: var(--size-200);
  padding: 0;
  text-align: left;
}

.clear:disabled {
  color: var(--text-faint);
  cursor: default;
}
